var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x8E Icon=Tags, Stroke=1.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3108 21.2742L21.2836 13.3014C21.7062 12.8787 21.9433 12.3053 21.9426 11.7076L21.9355 5.83477C21.935 5.42055 22.2703 5.08436 22.6846 5.08385C23.0988 5.08335 23.435 5.41873 23.4355 5.83294L23.4426 11.7058C23.4438 12.702 23.0486 13.6576 22.3443 14.362L14.3714 22.3349C14.0785 22.6277 13.6037 22.6277 13.3108 22.3349C13.0179 22.042 13.0179 21.5671 13.3108 21.2742Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7164 9.26752C13.4974 10.0486 14.7637 10.0486 15.5448 9.26752C16.3258 8.48647 16.3258 7.22014 15.5448 6.43909C14.7637 5.65804 13.4974 5.65804 12.7164 6.43909C11.9353 7.22014 11.9353 8.48647 12.7164 9.26752Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6668 11.1564C20.6619 11.8793 20.3726 12.5712 19.8614 13.0824L12.0465 20.8974C10.9725 21.9713 9.23133 21.9713 8.15739 20.8974L1.41874 14.1587C0.344797 13.0848 0.344795 11.3436 1.41874 10.2696L9.24323 2.44514C9.74662 1.94175 10.4256 1.65319 11.1374 1.64014L17.9129 1.51597C19.4584 1.48765 20.7236 2.73833 20.7132 4.28407L20.6668 11.1564ZM18.8008 12.0218C19.0331 11.7894 19.1646 11.4749 19.1669 11.1463L19.2132 4.27395C19.218 3.57134 18.6429 3.00285 17.9404 3.01572L11.1649 3.13989C10.8413 3.14582 10.5327 3.27699 10.3039 3.5058L2.4794 11.3303C1.99124 11.8184 1.99124 12.6099 2.4794 13.0981L9.21805 19.8367C9.7062 20.3249 10.4977 20.3249 10.9858 19.8367L18.8008 12.0218Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.c59c43f6218b59ce75e50310b5d600da.svg";
export { ForwardRef as ReactComponent };